module.exports = __webpack_public_path__ + "img/gongshang.9ce31135.png";